<template>
  <div class="container">
  

      <el-form ref="form" :model="searchFormData" :inline="true" >

            <el-form-item label="">
              <el-input  placeholder="输入名称搜索" v-model="searchFormData.keyword" clearable=""></el-input>
            </el-form-item>

            <el-button type="primary" @click="search">搜索</el-button>
         
      </el-form>


      <el-table
        ref="table"
        v-loading="searchLoading"
        :data="pageProps.records"
        element-loading-text="正在查询"
        fit
        stripe
        highlight-current-row
      >

      <el-table-column align="center" label="职位" prop="job_title"> </el-table-column>

        <el-table-column align="center" label="头像" prop="job_logo"> 
          <template slot-scope="{row}">
            <el-avatar :src="row.job_logo"></el-avatar>
          </template>
        </el-table-column>
        <el-table-column align="center" label="收藏时间"  prop="created_at"/>
      
        <el-table-column label="操作" fixed="right" align="center" class-name="small-padding fixed-width" width="200">
          <template slot-scope="{row}">
          
           <!-- <el-button  type="primary" size="mini" @click="edit(row.u_address_id)">
              编辑
            </el-button>-->

            <el-button  type="warning" size="mini" @click="cancelCollect(row)">
              取消收藏
            </el-button>

          </template>
        </el-table-column>
    </el-table>
    <div style="text-align:center;padding:20px">
      <!--分页-->
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageProps.total"
        :page-size="pageProps.pageSize"
        :page-sizes="[5, 10, 50, 100]"
        :current-page="pageProps.pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  
</div>
</template>

<script>

import { collectList,addCollect} from "@/api/user/collect/index.js";



export default {
  name: "Director-Work-Address",
  data() {
    return {
     
      searchLoading: false,
      pageProps: {
        records:[],
        total: 0,
        pageSize: 10,
        pageNum: 1
      },

      searchFormData:{
        type:1,
        keyword:"",
        page:0,
        limit:0
      }

    }
  },

  mounted() {
    this.fetchData();
  },



  methods: {

   
    cancelCollect(row){
      var that=this;
      this.$confirm('取消收藏?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
          const job_id	=row.job_id;
          addCollect({job_id:job_id,type:1,status:2}).then((response) => {
            console.log(response);
            if(response.code==200){
                that.fetchData();
            }
          });
        
      }).catch(() => {
      
      });
    },

    search(){
      this.fetchData();
    },

    fetchData(){
      var that = this;
      that.searchLoading=true;
      that.searchFormData.page=that.pageProps.pageNum;
      that.searchFormData.limit=that.pageProps.pageSize;

      collectList(that.searchFormData).then((response) => {
        that.searchLoading=false;
        console.log(response);
        if(response.code==200){
          that.pageProps.records = response.data.data;
          that.pageProps.total = response.data.total;
        }else{
          that.$message.error(response.msg?response.msg:"请求错误");
        }
       
      });
    },

     // 当前页变更
    handleCurrentChange(num) {
      this.pageProps.pageNum = num
      this.fetchData()
    },


    // 每页显示页面数变更
    handleSizeChange(size) {
      this.pageProps.pageSize = size
      this.fetchData()
    },
    
  }
}
</script>

